










































































import {
  PreCollection,
  PreCollectionContentType,
} from '@/resource/pre-collection/pre-collection.model';
import { Component, Prop, Vue } from 'vue-property-decorator';
import getLevelPremadePaper from '@/utils/common/get-level-premade-paper';
import generatePrecollectionUrl from '@/utils/common/generate-precollection-url';

@Component({
  components: {},
})
export default class PreCollectionItem extends Vue {
  @Prop({ required: true })
  preCollection!: PreCollection;

  get level() {
    return getLevelPremadePaper(this.preCollection.form);
  }

  itemClick() {
    const itemName = generatePrecollectionUrl(this.preCollection);

    this.$sendMpEvent({
      event: this.$mp_value.PremadePaperClick,
      properties: {
        uuid: this.preCollection.uuid,
        name: this.preCollection.name,
        form: this.preCollection.form,
        type: this.preCollection.type,
        year: this.preCollection.year,
        subjectUuid: this.preCollection.subject.uuid,
        isPremium: this.preCollection.isPremium,
        contentType: this.preCollection.course
          ? PreCollectionContentType.Course
          : this.preCollection.pdfLink
          ? PreCollectionContentType.Pdf
          : this.preCollection.collection
          ? PreCollectionContentType.Collection
          : PreCollectionContentType.PaperGenerated,
      },
    });

    const routeData = this.$router.resolve({
      path: `/browse/${itemName}`,
    });
    window.open(routeData.href, '_blank');
  }
}
